/*
 * Confidential and Proprietary.
 * Do not distribute without 1-800-Flowers.com, Inc. consent.
 * Copyright 1-800-Flowers.com, Inc. 2019. All rights reserved.
 */

export const ENUMS = Object.freeze({
    TWILIO_MAX_VALUE_TO_FORCE_SCROLL_DOWN: 100,
    RATING_HTML_TAG: '<Rating/>',
    PATTERN: {
        CHATBOT_BUTTONS: /{"Buttons":(\s?)\[(.*)\]}/,
        CHATBOT_INPUT: /(?:{"([A-z])*":)(?:\{)(.*)(?:"\}\})/,
    },
    DELAY_HTML_TAG: '<Delay/>',
    SMALL_SCREEN_SIZE: 767,
    COMMON_DATE_FORMAT: 'MM/DD/YYYY',
    CA_UNAVAILABE_ERROR_MSG: 'Unfortunately, this item does not ship to this state due to agricultural regulations.',
    SHOP_OTHER_COLLECTION: 'Please shop our collection of plants that are available in your delivery location.',
    AK_UNAVAILABLE_ERROR_MSG: "Sorry we don't ship to Hawaii or Alaska",
});

export default { ENUMS };
